import { AppEntities } from "../../../../config/entities";
import React from "react";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";

const AcquiringOperationsList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.AcquiringOperations} />
        </>
    );
}

export default AcquiringOperationsList;